import Galeria from '../componentes/Galeria';

export default function Palavras() {
  return (
    <Galeria
      tipo="video"
      titulo="Palavras"
      subtitulo="As pregacoes em vídeo, por culto."
      vazio="Nenhuma palavra publicada ainda."
    />
  );
}
